import { type PropsWithChildren } from 'react';
import { MercureContext } from './context';
import type { MercureEventSource } from '../lib/mercure-event-source';

export interface MercureProviderProps {
    client: MercureEventSource;
}

export const MercureProvider = ({ client, children }: PropsWithChildren<MercureProviderProps>) => {
    return <MercureContext.Provider value={client}>{children}</MercureContext.Provider>;
};
